export default __webpack_public_path__ + "static/media/icons8-secured-letter.f6f6cb1a.svg";